var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { motion } from "framer-motion";
import React from "react";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import PulseLoader from "react-spinners/PulseLoader";
import Swal from "sweetalert2";
import Meal from "./Meal";
import MealBuilderActions from "./MealBuilderActions";
import MealBuilderDayStats from "./MealBuilderDayStats";
import MealBuilderNavigation from "./MealBuilderNavigation";
import MealMenuModal from "./MealMenuModal";
const MAIN_CATS = [3, 4, 5];
const SNACK_CATS = [6, 8];
const mealContainerAnim = {
    hidden: { opacity: 0 },
    show: {
        opacity: 1,
        transition: {
            staggerChildren: 0.3,
        },
    },
};
export default class MealBuilder extends React.Component {
    constructor(props) {
        super(props);
        this.onSubmit = (e) => {
            const { result, day } = this.isFormValid();
            e.preventDefault();
            if (!result) {
                this.setState({
                    submitted: true,
                    activeDay: `day-${day}-tab`,
                });
                Swal.fire({
                    icon: "error",
                    title: "Incomplete",
                    html: "Some meals have not been selected yet.",
                });
                return;
            }
            //Else, submit the form as normal
            this.setState({
                isSubmitting: true,
            });
            e.currentTarget.closest("form").submit();
        };
        this.onResetForm = (e) => {
            e.preventDefault();
            Swal.fire({
                title: "Reset your plan?",
                text: "This will remove all meals and preferences so you can start again from the first step    ",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Cancel",
                confirmButtonText: "Lets start over",
                confirmButtonColor: "#B2303E",
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.href = "/plans?reset=true";
                }
            });
        };
        this.isFormValid = () => {
            //If invalidDay is null, the form is valid,
            // else it contains the first day that contains an error
            var invalidDay = null;
            var invalidMeal = null;
            this.state.meals.every((day, idx) => {
                day.every((meal, mealNo) => {
                    if (meal.variant_id == null) {
                        invalidDay = idx + 1;
                        invalidMeal = mealNo + 1;
                        return false;
                    }
                    return true;
                });
                return invalidDay == null;
            });
            return {
                result: invalidDay == null,
                day: invalidDay,
                meal: invalidMeal,
            };
        };
        this.switchDay = (dayNumber) => {
            this.setState({
                activeDay: `day-${dayNumber}-tab`,
            });
        };
        this.showChangeMenu = (e, meal) => {
            e.preventDefault();
            //{JSON.stringify(products.filter(p => p.id == layout![idx2].category_id) )}
            //Important variables to remember
            //const {category_id, day_number, meal_number, name, variant_id} = meal
            //Grab the sub-section of meals that this one may be replaced with
            const productCategory = this.state.products.filter((p) => p.id == meal.category_id)[0];
            this.setState({
                modalShow: true,
                modalMeal: meal,
                modalCategory: productCategory,
            });
        };
        this.hideChangeMenu = () => {
            this.setState({
                modalShow: false,
                modalCategory: null,
            });
        };
        this.updateMenu = (existing, selected) => {
            var meal = {
                category_id: selected.category_id,
                display_order: existing.display_order,
                day_number: existing.day_number,
                meal_number: existing.meal_number,
                name: selected.text,
                slug: "#",
                product_id: selected.product_id,
                variant_option: "#",
                variant_group: "#",
                variant_id: selected.id,
                type: selected.type,
                allergens: selected.allergens,
                nutriants: selected.nutriants,
                images: selected.images,
                tags: selected.tags
            };
            //Old code.. Stopped working for some reason
            // var newMealsState = [...this.state.meals]
            // const index = newMealsState[existing.day_number-1].findIndex(m => m.category_id == existing.category_id)
            // if(index > -1){
            //     newMealsState[existing.day_number-1].splice(index, 1, meal)
            // }
            //New code: actually updates stats
            const newMealsState = this.state.meals.map((day, idx) => {
                if (existing.day_number - 1 == idx) {
                    const dayData = [...this.state.meals[idx]];
                    const index = dayData.findIndex((m) => m.category_id == existing.category_id);
                    if (index > -1)
                        dayData.splice(index, 1, meal);
                    return dayData;
                }
                return day;
            });
            //Update the state
            this.setState({
                meals: newMealsState,
            });
            //If we're utilising a tempId, we should remotely update
            if (this.props.tempId != "") {
                fetch("/ajax/saveTempPlan", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    },
                    //@ts-ignore
                    body: new URLSearchParams({
                        uuid: this.props.tempId,
                        day_number: meal.day_number,
                        meal_number: meal.meal_number,
                        product_id: meal.product_id,
                        variant_id: meal.variant_id,
                    }),
                }).then((response) => response.text());
                //.then(data => Toast("success", "Success", "Yep yep eyp"));
            }
            return;
        };
        this.getMealDetails = (productVariantId, categoryId) => {
            const { products } = this.state;
            const cat = products.filter((c) => c.id == categoryId);
            const product = cat[0].children.filter((p) => p.id == productVariantId);
            //if(product)
            return product[0];
        };
        this.state = {
            isLoading: true,
            meals: [],
            products: [],
            layout: null,
            plan: {},
            filters: {
                diet: [],
                allergens: [],
                meats: []
            },
            options: {
                search: "",
                allergens: props.allergens.split(", ")
            },
            activeDay: "day-1-tab",
            modalShow: false,
            modalMeal: null,
            modalCategory: null,
            submitted: false,
            isSubmitting: false,
        };
        this.loadData();
    }
    render() {
        const { editId, cartId, tempId } = this.props;
        const { meals, plan, layout, filters, isLoading, isSubmitting } = this.state;
        const { modalShow, modalMeal, modalCategory, activeDay } = this.state;
        if (isLoading)
            return this.renderLoading();
        const actionLabel = editId == "" && cartId == "" ? "Add plan to cart" : "Update plan";
        return (React.createElement(motion.div, { className: "container-fluid", initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.7 } },
            React.createElement("div", { className: "row sticky-row" },
                React.createElement("div", { className: "col-lg" },
                    React.createElement(Tab.Container, { id: "planDayTab", defaultActiveKey: `day-1-tab`, activeKey: activeDay },
                        React.createElement(Nav, { className: "nav-tabs plan-day-tabs" }, meals.map((day, key) => (React.createElement(Nav.Item, { className: "nav-tabs plan-day-tabs", key: key },
                            React.createElement(Nav.Link, { eventKey: `day-${key + 1}-tab`, onClick: () => this.switchDay(key + 1) },
                                "Day ",
                                key + 1))))),
                        React.createElement(Tab.Content, { id: "planDayTabContent" }, meals.map((day, key) => (React.createElement(Tab.Pane, { eventKey: `day-${key + 1}-tab`, key: key },
                            React.createElement("div", { className: "row" },
                                React.createElement(motion.div, { className: "col-xl pb-5 pb-xl-0", variants: mealContainerAnim, initial: "hidden", animate: "show" },
                                    React.createElement("h2", { className: "h4" }, "Main meals"),
                                    day
                                        .filter((m) => MAIN_CATS.includes(m.category_id))
                                        .map((meal, idx) => (React.createElement(Meal, { key: `${meal.day_number}-${meal.meal_number}-${meal.variant_id}-${idx}`, meal: meal, category: layout.find((l) => l.category_id ==
                                            MAIN_CATS[idx]).category, onChange: this
                                            .showChangeMenu })))),
                                React.createElement(motion.div, { className: "col-xl", variants: mealContainerAnim, initial: "hidden", animate: "show" },
                                    React.createElement("h2", { className: "h4" }, "Snacks"),
                                    day
                                        .filter((m) => SNACK_CATS.includes(m.category_id))
                                        .map((meal, idx) => (React.createElement(Meal, { key: idx, meal: meal, category: layout.find((l) => l.category_id ==
                                            SNACK_CATS[idx]).category, onChange: this
                                            .showChangeMenu }))))),
                            React.createElement(MealBuilderDayStats, { meals: day, dayNumber: key + 1 }),
                            React.createElement(MealBuilderNavigation, { dayNumber: key + 1, totalDays: meals.length, onSwitch: this.switchDay }))))))),
                React.createElement("div", { className: "col-lg-auto sticky-col" },
                    React.createElement("div", { className: "sticky-actions" },
                        React.createElement(MealBuilderActions, { actionLabel: actionLabel, onSubmit: this.onSubmit, meals: meals, plan: plan, isLoading: isSubmitting }),
                        tempId != "" && (React.createElement("a", { href: "#", className: "btn btn-link mt-3 d-block mx-0", onClick: (e) => this.onResetForm(e) },
                            React.createElement("i", { className: "far fa-arrow-rotate-right fa-flip-horizontal" }),
                            " ",
                            "Reset plan")),
                        React.createElement("div", { className: "alert alert-solid-info mt-3" },
                            React.createElement("p", null, "All meal plans will be temporarily delivered in two batches to maintain freshness."),
                            React.createElement("p", null, "If your selected delivery date is a Sunday or Monday, the second half will arrive on Wednesday. If your selected delivery date is Tuesday or Wednesday, the second half will arrive Sunday."),
                            React.createElement("p", null, "Delivery notifications will be sent out through account emails! Please be sure to check in the morning of your delivery. The email will have a tracking link and the approximate arrival of your order.")))),
                React.createElement(MealMenuModal, { show: modalShow, selectedMeal: modalMeal, category: modalCategory, filters: filters, onExit: this.hideChangeMenu, onUpdate: this.updateMenu }))));
    }
    renderLoading() {
        const colour = "#000";
        return (React.createElement("div", { style: {
                margin: "0 auto",
                textAlign: "center",
            } },
            React.createElement(PulseLoader, { color: colour, loading: true, speedMultiplier: 0.8, cssOverride: {
                    margin: "0 auto",
                    marginTop: "10%",
                    marginBottom: "20px",
                } }),
            React.createElement("div", null, "Loading your plan")));
    }
    //Load all data
    loadData() {
        return __awaiter(this, void 0, void 0, function* () {
            const { id, allergens, protein, mode, editId, lineId, cartId, tempId } = this.props;
            yield Promise.all([
                //Grab the menu - Whether than be auto-generated, or loaded from existing data
                //id        : id of meal plan to generate from
                //allergens : comma-separated list of allergies the user has
                //protein   : proteinType is user requests
                //mode      : "auto" generate, "or "manual"
                this.loadRemoteData(`/ajax/getPlanDetails?id=${id}&allergens=${allergens}&proteinType=${protein}&mode=${mode}&editId=${editId}&lineId=${lineId}&cartId=${cartId}&tempId=${tempId}`, ["meals", "plan"]),
                //Grab a list of all products that can be used in this plan
                //id        : if of meal plan to get products for
                this.loadRemoteData(`/ajax/getPlanProducts?planId=${id}`, "products"),
                //Returns the layout for the plan
                this.loadRemoteData(`/ajax/getPlanLayout`, "layout"),
                //Returns available filter options
                this.loadRemoteData(`/ajax/getPlanFilters`, "filters"),
            ]);
            this.setState({
                isLoading: false,
            });
        });
    }
    //Load remote data and updates the states 'stateVar' value
    loadRemoteData(url, stateVar) {
        return __awaiter(this, void 0, void 0, function* () {
            yield fetch(url)
                .then((resp) => {
                if (resp.ok)
                    return resp.json();
            })
                .then((data) => {
                if (typeof stateVar == "string") {
                    const name = stateVar;
                    this.setState(Object.assign(Object.assign({}, this.state), { [name]: data }));
                }
                else {
                    var obj = {};
                    stateVar.forEach((key) => {
                        obj[key] = data[key];
                    });
                    //const name = stateVar as keyof typeof this.state
                    this.setState(Object.assign(Object.assign({}, this.state), obj));
                }
            });
        });
    }
}
